import React from 'react'

function WomanKey() {
  return (
    <svg width={234} height={245} viewBox="0 0 234 245" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M125.454.218c35.724 2.477 60.911 32.106 81.624 61.286 18.872 26.584 31.505 57.408 25.349 89.412-6.424 33.401-26.61 63.933-57.566 78.095-30.333 13.878-64.21 4.986-94.762-8.405-32.42-14.209-65.727-32.564-75.959-66.42-10.938-36.194.72-75.369 24.13-105.078C51.87 19.154 87.384-2.421 125.453.218z"
        fill="#F3F5F8"
      />
      <path
        d="M118.555 232.465h-7.221v4.829h7.221v-4.829zM154.172 223.53l-5.273 4.263 3.774 4.675 5.273-4.263-3.774-4.675zM123.013 35.636h.332a2.705 2.705 0 012.689 2.691v1.4a2.705 2.705 0 01-2.689 2.692h-.332a2.706 2.706 0 01-2.689-2.691v-1.401a2.682 2.682 0 012.689-2.691z"
        fill="#B3B3B3"
      />
      <path
        d="M125.592 137.316c.995 2.249 8.511 47.41 9.616 51.65 1.106 4.276 18.79 32.11 19.969 33.769.369 2.397-5.084 6.489-7.663 6.489-2.579-2.065-32.827-45.862-33.527-47.816-.774-1.917-3.206-48.479 11.605-44.092z"
        fill="#C01414"
      />
      <path
        d="M94.017 129.866c-.331 1.88 4.753 44.461 5.416 50.175.627 5.715 10.427 51.835 11.275 52.977.884 1.143 7.442.885 8.584.332 1.142-.553-2.211-48.074-2.211-51.502 0-3.429 8.806-35.208 7.701-44.387-1.106-9.18-30.764-7.595-30.764-7.595z"
        fill="#D62929"
      />
      <path d="M119.071 78.215h-6.89v12.018h6.89V78.215z" fill="#B3B3B3" />
      <path
        d="M114.724 80.17c5.229 0 9.468-5.71 9.468-12.755 0-7.045-4.239-12.756-9.468-12.756-5.23 0-9.469 5.711-9.469 12.756s4.239 12.756 9.469 12.756z"
        fill="#B3B3B3"
      />
      <path
        d="M113.434 87.728c-11.495 0-21.738 31.89-19.748 42.471.59 3.133 28.075 9.437 32.275 8.553 1.474-2.028 7.59-51.024-12.527-51.024z"
        fill="#4D4D4D"
      />
      <path
        d="M110.487 105.496c5.158-3.723-3.095-21.825-5.011-22.156-3.537-.59-12.343 6.23-12.048 9.069.148 1.511 11.827 16.885 17.059 13.087z"
        fill="#4D4D4D"
      />
      <path
        d="M95.05 91.082c-1.4-1.659-4.864-9.806-5.233-11.76-.368-1.918-1.29-30.968-1.29-32.7 0-1.734-2.283-6.047-2.283-8.664 0-2.581 2.615-6.12 3.979-6.157 1.437 1.032 3.426 6.968 3.5 8.516.516-3.281 2.874-4.019 3.5-4.019.626 0 .553 5.051-2.1 8.443.11 2.507 3.279 27.244 3.795 28.682.516 1.438 6.374 10.802 6.337 11.65-.037.848-10.206 6.009-10.206 6.009zM126.329 60.998c-.258-1.548-.516-12.792-.11-14.377.405-1.586 1.547-2.729 2.063-5.125.184-.81-.111-3.65-.663-3.76-1.179-.258-1.253 1.069-1.4 2.064-.59 3.355-1.843 2.728-2.432 2.655-.59-.074-2.542-.406-3.169-.443-.626 0 .995 1.29.479 3.429-.405 1.659-2.247 12.756-2.616 14.562 1.4.11 7.848.995 7.848.995z"
        fill="#B3B3B3"
      />
      <path
        d="M168.809 38.143c-4.2-.59-8.105 1.954-9.395 5.862L49.769 29l-.443 3.318L48 41.903l7.074.959.847-6.194 3.022.406-.848 6.193 3.832.516.847-6.193 2.69.368-.848 6.194 3.832.516 1.326-9.585 89.235 12.203c.258 4.018 3.316 7.447 7.479 8.037 4.753.663 9.101-2.655 9.764-7.41a8.707 8.707 0 00-7.443-9.77zm4.68 9.4a5.906 5.906 0 01-11.68.148l3.464.48.442-3.318-3.5-.48c1.031-2.36 3.536-3.87 6.226-3.502 3.242.442 5.49 3.429 5.048 6.673z"
        fill="#737373"
      />
      <path
        d="M95.16 44.743c-.443-1.696-1.29-3.17-1.4-4.424v.037c-.074-1.512-2.064-7.484-3.5-8.516-1.327.037-3.98 3.576-3.98 6.156 0 1.918 1.253 4.756 1.916 6.784h6.927l.036-.037z"
        fill="#B3B3B3"
      />
      <path
        d="M106.176 59.454c0 4.424 3.095 7.115 8.032 8.664 0 6.046.921 6.304.921 9.99 0 7.927-1.363 3.945-1.363 17.623 0 8.258 3.463 12.719 9.8 12.719 7.7 0 12.084-8.148 12.084-12.498 0-5.567-5.489-15.226-5.894-23.226-.516-10.802-3.869-19.834-12.306-19.834-7.111-.037-11.274 2.654-11.274 6.562z"
        fill="#000"
      />
      <path
        d="M114.723 71.654a2.544 2.544 0 10-.001-5.087 2.544 2.544 0 00.001 5.087z"
        fill="#B3B3B3"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M157.904 227.269l4.089 5.566-8.547 12.093-8.069.036.11-4.092 3.243-1.438 2.873-7.115 6.301-5.05z"
        fill="#000"
      />
      <path
        d="M119.034 236.852v8.147H95.123v-3.613l15.769-4.534h8.142z"
        fill="#000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.702 73.696c.168.09.23.3.139.468a4.276 4.276 0 01-.77 1c-.291.28-.654.543-1.015.603a.345.345 0 11-.113-.68c.146-.025.383-.163.65-.42a3.6 3.6 0 00.641-.832.345.345 0 01.468-.139z"
        fill="#1F161E"
      />
      <ellipse cx={107.5} cy={68} rx={0.5} ry={1} fill="#0D0D0D" />
      <path
        d="M108 72c.552 0 1-.224 1-.5s-.448-.5-1-.5-1 .224-1 .5.448.5 1 .5z"
        fill="#FA9E9F"
      />
    </svg>
  )
}

export default React.memo(WomanKey)
